import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

export enum StepId {
  InvestmentObjective = 'investmentObjective',
  TimeHorizon = 'timeHorizon',
  HypotheticalPortfolio = 'hypotheticalPortfolio',
  RiskLevel = 'riskLevel',
  DownMarket = 'downMarket',
  IncomeStability = 'incomeStability',
  EmergencyHandling = 'emergencyHandling',
}

export type AnswersDTO = Record<StepId, number>;

const fetchRiskToleranceWorkflow = async (clientId: string): Promise<AnswersDTO | null> => {
  return authFetch(
    urlWithParams('/Consumer/RiskToleranceWorkflow', {
      clientId,
    }),
  );
};

interface RiskToleranceWorkflowQueryParams {
  clientId: string;
}

export const useRiskToleranceWorkflowQuery = ({ clientId }: RiskToleranceWorkflowQueryParams) => {
  return useQuery(
    queryKeys.riskToleranceWorkflow(clientId),

    () => fetchRiskToleranceWorkflow(clientId),

    { cacheTime: 0 },
  );
};
